
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-to-sketch",
      function () {
        return require("private-next-pages/photo-to-sketch/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-to-sketch"])
      });
    }
  